import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';
import {Image, Menu} from 'semantic-ui-react';
import {string, bool, arrayOf, shape, object, func, oneOfType, number} from 'prop-types';
import {EmptyFunc, makeDBContentImageUrl} from 'utils/DBUtils';
import FieldStatusIcon from 'components/forms/FieldStatusIcon';
import ImageButtons from 'components/images/ImageButtons';
import DropdownInput from './DropdownInput';

export default class ImagePicker extends React.Component {
  static propTypes = {
    editImageInfo: func,
    editImage: func,
    hasOriginalImage: bool,
    isUploading: bool,
    loading: bool,
    name: string.isRequired,
    onBrowse: func,
    onValueChanged: func,
    options: arrayOf(
      shape({
        text: string.isRequired,

        // constrained by Dropdown.Item 'value' propType:
        value: oneOfType([string, number, bool])
      })
    ),
    possibleImages: arrayOf(
      shape({
        id: string.isRequired,
        name: string.isRequired
      })
    ),
    selectedImage: shape({
      imageType: string.isRequired
    }),
    selectedImageId: string
  };

  static defaultProps = {
    editImageInfo: EmptyFunc,
    editImage: EmptyFunc,
    hasOriginalImage: false,
    isUploading: false,
    name: null,
    onBrowse: EmptyFunc,
    onValueChanged: EmptyFunc,
    options: [],
    possibleImages: [],
    selectedImage: null,
    selectedImageId: null
  };

  selectImage = imageId => {
    this.props.onValueChanged(imageId, this.props.name);
  };

  removeImage = () => {
    this.selectImage(null);
  };

  render() {
    // only render a non-original if it's the current selected image.
    const shouldRenderImage = this.props.selectedImage
      ? this.props.selectedImage.imageType !== 'original'
      : true;

    const isNotEditable = this.props.editable === false;

    return (
      <div className='db-basic-image-picker'>
        <DropdownInput
          {...this.props}
          value={this.props.selectedImageId || null} />
        {this.props.selectedImageId && !this.props.loading ? (
          <section className='image-picker-preview'>
            {shouldRenderImage && <Image src={makeDBContentImageUrl(this.props.selectedImageId)} />}
            <div className='image-preview-controls'>
              <Menu.Item
                disabled={isNotEditable}
                onClick={this.removeImage}>
                <FormattedMessage id='images.picker.action.remove' />
              </Menu.Item>
              |&nbsp;
              <Menu.Item
                disabled={isNotEditable}
                onClick={this.props.editImageInfo}>
                <FormattedMessage id='images.picker.action.editInfo' />
              </Menu.Item>
              {this.props.hasOriginalImage && (
                <Fragment>
                  &nbsp;|
                  <Menu.Item
                    disabled={isNotEditable}
                    onClick={this.props.editImage}>
                    <FormattedMessage id='images.picker.action.editImage' />
                  </Menu.Item>
                </Fragment>
              )}
            </div>
          </section>
        ) : this.props.loading ? (
          <div className='creating-image-info'>
            <p>
              <FormattedMessage id='images.picker.status.creatingImage' />
              &nbsp;
              <FieldStatusIcon show isSaving />
            </p>
          </div>
        ) : (
          <ImageButtons
            disabled={this.props.isUploading}
            onBrowse={this.props.onBrowse}
            onIdEntered={this.selectImage} />
        )}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/ImagePicker.jsx